import React from 'react'
import AwsConfig from '../../Config/AwsConfig'
import TableColumnValues from './TableColumnValues'
import Tableheaders from './Tableheaders'
export default function Table(props) {
  const {
      personsObjectData,
      editFunction,
      onAddingItem,
      deleteFunction,
      status,
      approvePerson,
      ApproveOptionPermission,
      EDitOptionPermission,
      DeleteOptionPermission,
    } = props
  const tableData =
    personsObjectData &&
    personsObjectData.map((item, index) => {
      let posterUrl = item.posterURL
      const cdnurl = AwsConfig.movieCdnUrl
      // console.log(cdnurl, 'this is cdnurlllll')
      // console.log(posterUrl, 'this is uriiiiiiiiiii')
      if (posterUrl && !posterUrl.includes(cdnurl)) {
        posterUrl = cdnurl + posterUrl
        // console.log(posterUrl, 'this is inside if condition')
      }

      return (
        <TableColumnValues
          key={index}
          index={index}
          item={item}
          onAddingItem={onAddingItem}
          posterUrl={posterUrl}
          editFunction={editFunction}
          deleteFunction={deleteFunction}
          status={status}
          approvePerson={approvePerson}
          ApproveOptionPermission={ApproveOptionPermission}
          EDitOptionPermission={EDitOptionPermission}
          DeleteOptionPermission={DeleteOptionPermission}
        />
      )
    })
  return (
    <div>
      <Tableheaders tableData={tableData} />
    </div>
  )
}
